_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
{ Analytics } = require '@trello/atlassian-analytics'
Controller = require 'app/scripts/controller'

getPlugin = (idPlugin) ->
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  ModelCache = require 'app/scripts/db/model-cache'

  return ModelCache.get('Plugin', idPlugin)

getBoard = (idBoard) ->
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  ModelCache = require 'app/scripts/db/model-cache'

  return ModelCache.get('Board', idBoard)

getPluginName = (plugin) ->
  plugin.get('listing')?.name || plugin.get('name')

getAndExtendCommonAttributes = (plugin, attributes = {}) ->
  commonAttributes =
    powerUpId: plugin.id
    powerUpName: if plugin.get('public') then getPluginName(plugin) else undefined
    isPowerUpPublic: plugin.get('public')
    idOrganizationOwner: plugin.get('idOrganizationOwner')

  me = Auth.me()

  if !attributes.boardId
    attributes.boardId = Controller.getCurrentBoard()?.id

  if attributes.boardId
    board = getBoard(attributes.boardId)
    if board
      commonAttributes.organizationId = board.get('idOrganization')
      commonAttributes.powerUpsCount = board.powerUpsCount()
      commonAttributes.limitedPowerUpsCount = board.limitedPowerUpsCount()
      commonAttributes.canEnableAdditionalPowerUps = board.canEnableAdditionalPowerUps()
      commonAttributes.boardPaidStatus = switch
        when board.isEnterpriseBoard() then 'enterprise'
        when board.getOrganization()?.isBusinessClass() then 'bc'
        else 'free'

  if me?
    commonAttributes.maxUserPaidStatus = switch
      when me.enterpriseList.length then 'enterprise'
      when me.hasBCPowerUps() then 'bc'
      when me.isGold() then 'gold'
      else 'free'

  return _.extend attributes, commonAttributes

sendPluginScreenEvent = (idPlugin, screenName, attributes = {}) ->
  try
    plugin = getPlugin(idPlugin)

    if plugin
      Analytics.sendScreenEvent
        name: screenName
        attributes: getAndExtendCommonAttributes(plugin, attributes)
  catch
    console?.warn('Failed to send plugin screen event.')

sendPluginUIEvent = (idPlugin, event) ->
  try
    plugin = getPlugin(idPlugin)

    if plugin && event
      attributes = event.attributes || {}
      Analytics.sendUIEvent(
        _.extend event, attributes: getAndExtendCommonAttributes(plugin, attributes)
      )
  catch
    console?.warn('Failed to send plugin UI event.')

sendPluginTrackEvent = (idPlugin, event) ->
  try
    plugin = getPlugin(idPlugin)

    if plugin && event
      attributes = event.attributes || {}
      Analytics.sendTrackEvent(
        _.extend event, attributes: getAndExtendCommonAttributes(plugin, attributes)
      )
  catch
    console?.warn('Failed to send plugin track event.')

module.exports = {
  sendPluginScreenEvent
  sendPluginUIEvent
  sendPluginTrackEvent
}
